import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loggedIn: false,
  username: null,
  firstname: null,
  lastname: null,
  authToken: null,
  totp: null,
  clientName: null,
  loginLoading: false,
  loginSuccess: false,
  loginFail: false,
};

const AuthenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem("authToken");

      return {
        ...state,
        loggedIn: false,
        username: null,
        firstname: null,
        lastname: null,
        authToken: null,
        totp: null,
        clientName: null,
      };
    },
    login: (state) => {
      localStorage.removeItem("authToken");

      return {
        ...state,
        loggedIn: false,
        username: null,
        firstname: null,
        lastname: null,
        authToken: null,
        totp: null,
        clientName: null,
        loginLoading: true,
        loginSuccess: false,
        loginFail: false,
      };
    },
    login_SUCCESS: (state, { payload }) => {
      localStorage.setItem("authToken", payload.data.authToken);

      return {
        ...state,
        loggedIn: true,
        username: payload.data.username,
        firstname: payload.data.firstname,
        lastname: payload.data.lastname,
        authToken: payload.data.authToken,
        totp: payload.data.totp,
        clientName: payload.data.clientName,
        loginLoading: false,
        loginSuccess: true,
        loginFail: false,
      };
    },
    login_FAIL: (state) => {
      localStorage.removeItem("authToken");

      return {
        ...state,
        loggedIn: false,
        username: null,
        firstname: null,
        lastname: null,
        authToken: null,
        totp: null,
        clientName: null,
        loginLoading: false,
        loginSuccess: false,
        loginFail: true,
      };
    },
    resetLogin: (state) => {
      localStorage.removeItem("authToken");

      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const { logout, resetLogin } = AuthenticationSlice.actions;

export default AuthenticationSlice.reducer;

export const login = (credentials) => ({
  type: "authentication/login",
  payload: {
    client: "default",
    request: {
      method: "post",
      data: credentials,
      url: "portal/login",
    },
  },
});
